import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import PricingCard from './pricing/PricingCard';
import TierCard from './pricing/TierCard';
import PricingModal from './pricing/PricingModal';
import ReactModal from 'react-modal';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import * as ROUTES from '../../constants/routes';
import parse from 'html-react-parser';
import CreateCompanyModal from '../company/CreateCompanyModal';
import {openCompanyModal} from '../../store/actions/companyActions'
const ViewButton = styled.div`
    .btn {
        color: #fafafa;
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.themeColor};
        margin: 2px;

        &:hover {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }

        &:active {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }
    }
`;

class Pricing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPaymentModal: false,
        }
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = () => {
        this.props.openCompanyModal();
        this.setState({ showPaymentModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showPaymentModal: false });
    }

    render() {
        const desStyle = {
            fontSize: "18px",
        };

        const fontStyle = {
            fontSize: '14px',
            backgroundColor: 'transparent',
            height: '65px',
            maxHeight: '70px'

        }

        const { userData, companyData, isSignedIn, dashboardSidebarSize, store, storeInfo, modalStyles, themeColors, commons,company } = this.props;
        const {isModalCalled} = company;
        // console.log(isModalCalled)
        const marginLeft = isSignedIn ? dashboardSidebarSize : 0;
        const storeList = store ? Object.values(store) : [];
        const storeTiers = storeInfo ? Object.values(storeInfo.tiers).filter((eachTier) => eachTier.available) : [];
        // console.log(storeTiers);

        const isFreeTrialAvailed = companyData ? 'isFreeTrialAvailed' in companyData ? companyData.isFreeTrialAvailed : false : false;
        const relevantFreeTrialButton = isSignedIn ? isFreeTrialAvailed ? <React.Fragment /> : <a className="btn btn-flat" href="#!" role="button" onClick={this.handleOpenModal}>Get started for <strong>free</strong> now!</a> : <Link to={ROUTES.SIGN_UP} className="btn btn-flat my-3">Sign up and get started for <strong>free</strong></Link>

        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div style={{ marginLeft: marginLeft, marginTop: '40px', marginBottom: '100px', paddingInline: "0px" }}>
                        <div style={{ marginLeft: "0px", marginRight: "0px" }}>
                            <div className="jumbotron pb-2">
                                <h2 className=""><b>Pricing Plans</b></h2>
                                <p className="lead container" style={desStyle}>Our plans are designed to cater to a range of team sizes in different sectors</p>
                                {isFreeTrialAvailed ? <React.Fragment/> : <hr className="my-4" />}
                                <span className="lead">
                                    {isFreeTrialAvailed ? <React.Fragment /> : <p>{storeInfo ? isSignedIn ? userData.coid === '-1' ? storeInfo.trialPeriodMessageNoCom : storeInfo.trialPeriodMessage : storeInfo.trialPeriodMessageNew : ''}</p>}
                                    <ViewButton themeColors={themeColors}>
                                        {relevantFreeTrialButton}
                                    </ViewButton>
                                </span>
                            </div>
                            <div style={{ paddingInline: '20px' }}>
                                <div className="row row-cols-1 row-cols-xl-5">
                                    <div className="pricinghintcol">
                                        <div className="card h-100" style={{ textAlign: 'start', borderRadius: '0px' }}>
                                            <div className="card-header" style={{ height: '150px', backgroundColor: themeColors.themeColor }}>
                                                {storeInfo ? parse(storeInfo.discountMessage) : <React.Fragment />}
                                            </div>
                                            <div className="" style={{ backgroundColor: 'white' }}>
                                                <ul className="list-group  list-group-flush ">
                                                    <li className="list-group-item" style={fontStyle}><strong>Tag limit</strong>
                                                        <p style={{ fontSize: '12px', color: '#141414', paddingTop: '5px', paddingBottom: '3px' }}>(View more option using dropdown)</p>
                                                    </li>
                                                    <li className="list-group-item" style={fontStyle}><strong>Project tag limit</strong></li>
                                                    <li className="list-group-item" style={fontStyle}><strong>Company members</strong></li>
                                                    <li className="list-group-item" style={fontStyle}><strong>Internal {commons.project} members</strong></li>
                                                    <li className="list-group-item " style={fontStyle}><strong>External {commons.project} members</strong></li>
                                                </ul>
                                            </div>

                                            <div className="card-footer mt-auto" style={{ backgroundColor: "white", borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px', height: '100px', maxHeight: '200px' }}>
                                                {storeInfo ? parse(storeInfo.pricingDisclaimer) : <React.Fragment />}
                                            </div>
                                        </div>
                                    </div>
                                    {storeTiers.sort((a, b) => a.sno - b.sno).filter((eachTier) => eachTier.tierId !== 'tier_free').filter((eachTier) => eachTier.tierId !== 'tier_!test').map((eachTier) => {
                                        const listOfProducts = storeList.filter((eachProduct) => eachProduct.tierId === eachTier.tierId).sort((a, b) => a.tagLimit - b.tagLimit);
                                        return <div className="pricingcard" key={eachTier.tierId}><TierCard key={eachTier.tierId} tier={eachTier} listOfProducts={listOfProducts} /></div>
                                    })}
                                </div>
                            </div>
                            {/* {storeList.length > 0 ?
                            <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-3">
                                {storeList.filter((priceCard) => priceCard.hidden === false).map((priceCard, index) => <PricingCard key={index} priceCard={priceCard} />)}
                            </div>
                            : <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>} */}
                        </div>
                    </div>
                </div>

                {/* PAYMENT SELECTION MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showPaymentModal&&!isModalCalled}
                    onRequestClose={() => { this.handleCloseModal() }}
                    contentLabel="See all payment methods"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal() }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <CreateCompanyModal />
                    {/* <PricingModal priceCard={storeList.filter((e) => e.tierId === "tier_free")[0]} storeInfo={storeInfo} /> */}
                </ReactModal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        userData: state.firebase.profile,
        isSignedIn: !state.firebase.auth.isEmpty,
        store: state.firestore.data.Store,
        storeInfo: state.firestore.data.StoreInfo,
        modalStyles: state.appControl.modalStyles,
        companyData: state.firestore.data.Company,
        commons: state.commons,
        appControl: state.appControl,
        company:state.company,
    }
}
const mapDispatchToProps = (dispatch) => {
    return{
        openCompanyModal: ()=> dispatch(openCompanyModal()),
    }
}

export default compose(
    connect(mapStateToProps,mapDispatchToProps),
    firestoreConnect((props) => {
        const { isTestApp } = props.appControl;
        // console.log(isTestApp);
        return [
            {
                collection: "Store",
                storeAs: "Store",
                // For testing purpose testProduct will be true.
                // In production testProduct will be false.
                where: [['testProduct', '==', isTestApp]],
            },
            {
                collection: "Configurations",
                doc: "StoreInfo",
                storeAs: "StoreInfo",
            }
        ]
    })
)(Pricing);